import { getInstance } from '../initialiser';
import { draw } from '../../utils';

import { Details, Mol } from '../../types';

export default abstract class MoleculeBase {
  _mol: Mol;

  constructor(mol: Mol) {
    this._mol = mol;
  }

  delete(): void {
    this._mol.delete();
  }

  static getSvgFromSmiles(
    smiles: string,
    smarts?: string,
    details?: Details,
    width?: number,
    height?: number,
    offsetx?: number,
    offsety?: number
  ): string {
    const {
      exports: { get_qmol, get_mol },
    } = getInstance();
    const mol = get_mol(smiles);
    const qmol = smarts ? get_qmol(smarts) : undefined;

    return draw(mol, qmol, undefined, details, width, height, offsetx, offsety);
  }

  static drawCanvasFromSmiles(
    canvas: HTMLCanvasElement,
    smiles: string,
    smarts?: string,
    details?: Details,
    width?: number,
    height?: number,
    offsetx?: number,
    offsety?: number
  ): void {
    const {
      exports: { get_qmol, get_mol },
    } = getInstance();
    const mol = get_mol(smiles);
    const qmol = smarts ? get_qmol(smarts) : undefined;

    draw(mol, qmol, canvas, details, width, height, offsetx, offsety);
  }

  toSmiles(): string {
    return this._mol.get_smiles();
  }

  toCXSmiles(): string {
    return this._mol.get_cxsmiles();
  }

  toSmarts(): string {
    return this._mol.get_smarts();
  }

  toMdl(): string {
    return this._mol.get_molblock();
  }

  toV3Mdl(): string {
    return this._mol.get_v3Kmolblock();
  }

  getSvg(
    qmol?: Mol,
    details?: Details,
    width?: number,
    height?: number,
    offsetx?: number,
    offsety?: number
  ): string {
    return draw(
      this._mol,
      qmol,
      undefined,
      details,
      width,
      height,
      offsetx,
      offsety
    );
  }

  drawCanvas(
    canvas: HTMLCanvasElement,
    qmol?: Mol,
    details?: Details,
    width?: number,
    height?: number,
    offsetx?: number,
    offsety?: number
  ): void {
    draw(this._mol, qmol, canvas, details, width, height, offsetx, offsety);
  }

  getSubstructMatch(qmol: Mol): string {
    return this._mol.get_substruct_match(qmol);
  }

  getSubstructMatches(qmol: Mol): string {
    return this._mol.get_substruct_matches(qmol);
  }

  isValid(): boolean {
    return this._mol.is_valid();
  }
}
